// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_attachment_files from "./web_attachment_files.js";
import * as Mapre_web__Web_attachments_model from "./web_attachments_model.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Hashtbl from "melange/hashtbl.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function draft(target, model) {
  if (target === /* Initial */ 0) {
    return Stdlib__Option.fold(Mapre_web__Web_attachments_model.initial, (function (form) {
      return form.attachments;
    }), model.form);
  } else {
    return model.messages.attachments;
  }
}

function allowed(target, model) {
  if (Mapre_web__Web_model.can_create(model) && !Mapre_web__Web_model.locked(model)) {
    if (target === /* Initial */ 0) {
      return Stdlib__Option.fold(false, (function (form) {
        return !form.pending;
      }), model.form);
    } else if (model.messages.attempt === undefined) {
      return !model.messages.denied;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function scope(target, model) {
  const match = Mapre_web__Web_types.workspace(model.route);
  const match$1 = Mapre_web__Web_types.project(model.route);
  if (match === undefined) {
    return;
  }
  if (match$1 === undefined) {
    return;
  }
  let tmp;
  tmp = target === /* Initial */ 0 ? Stdlib__Option.map((function (form) {
      return form.request_id;
    }), model.form) : Mapre_web__Web_types.session(model.route);
  return Stdlib__Option.map((function (id) {
    return [
      id,
      match,
      match$1
    ];
  }), tmp);
}

function cancel(t) {
  t.generation = t.generation + 1 | 0;
  Stdlib__Hashtbl.iter((function (param, param$1) {
    Mapre_web__Browser.abort(param$1[1]);
  }), t.uploads);
  Stdlib__Hashtbl.clear(t.uploads);
}

function cancel_target(t, target) {
  const pending = Stdlib__Hashtbl.fold((function (key, param, acc) {
    if (param[0] === target) {
      return {
        hd: [
          key,
          param[1]
        ],
        tl: acc
      };
    } else {
      return acc;
    }
  }), t.uploads, /* [] */ 0);
  Stdlib__List.iter((function (param) {
    Mapre_web__Browser.abort(param[1]);
    Stdlib__Hashtbl.remove(t.uploads, param[0]);
  }), pending);
}

function emit(t, target, action) {
  Curry._1(t.emit, {
    TAG: /* Attachments */ 44,
    _0: target,
    _1: action
  });
}

function fail(t, target, key, error) {
  if (!/* tag */ (typeof error !== "object" && typeof error !== "function")) {
    if (error.TAG === /* Missing */ 0) {
      return emit(t, target, {
        TAG: /* Upload_failed */ 2,
        _0: key,
        _1: "Attachment upload is unavailable for this project."
      });
    } else {
      return emit(t, target, {
        TAG: /* Upload_failed */ 2,
        _0: key,
        _1: error._0
      });
    }
  }
  switch (error) {
    case /* Unauthorized */ 0 :
      return Curry._1(t.failure, error);
    case /* Forbidden */ 1 :
      return emit(t, target, {
        TAG: /* Upload_failed */ 2,
        _0: key,
        _1: "Permission denied. Refresh your access before uploading."
      });
    case /* Invalid_response */ 2 :
      return emit(t, target, {
        TAG: /* Upload_failed */ 2,
        _0: key,
        _1: "Invalid attachment upload response."
      });
  }
}

function upload(t, target, captured, file) {
  const match = Mapre_web__Web_attachment_files.find(file.key);
  if (captured !== undefined && match !== undefined) {
    const generation = t.generation;
    const controller = new AbortController();
    Stdlib__Hashtbl.replace(t.uploads, file.key, [
      target,
      controller
    ]);
    const headers_0 = [
      "Content-Type",
      "application/octet-stream"
    ];
    const headers_1 = {
      hd: [
        "X-Mapre-Attachment-Name",
        encodeURIComponent(file.name)
      ],
      tl: {
        hd: [
          "X-Mapre-Content-Type",
          file.media_type
        ],
        tl: {
          hd: [
            "X-Mapre-Request-Id",
            file.key
          ],
          tl: /* [] */ 0
        }
      }
    };
    const headers = {
      hd: headers_0,
      tl: headers_1
    };
    Mapre_web__Browser.upload(controller, headers, Caml_option.valFromOption(match), "/api/workspaces/" + (captured[1] + ("/projects/" + (captured[2] + "/attachments")))).then(function (result) {
      Stdlib__Hashtbl.remove(t.uploads, file.key);
      if (generation === t.generation && Caml_obj.caml_equal(captured, scope(target, Curry._1(t.model, undefined))) && Stdlib__List.mem(file.key, Mapre_web__Web_attachments_model.keys(draft(target, Curry._1(t.model, undefined))))) {
        if (result.TAG === /* Ok */ 0) {
          try {
            const reference = Mapre_web__Web_attachments_model.decode(Mapre_wire__Json.get(result._0, "attachment"));
            if (reference.name !== file.name || reference.size !== file.size || reference.media_type !== file.media_type) {
              throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
                  MEL_EXN_ID: Mapre_wire__Json.Invalid,
                  _1: "attachment_metadata_changed"
                });
            }
            emit(t, target, {
              TAG: /* Uploaded */ 1,
              _0: file.key,
              _1: reference
            });
          }
          catch (raw_exn){
            const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
            if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
              fail(t, target, file.key, /* Invalid_response */ 2);
            } else {
              throw exn;
            }
          }
        } else {
          fail(t, target, file.key, result._0);
        }
      }
      return Promise.resolve();
    });
    return;
  }
  emit(t, target, {
    TAG: /* Upload_failed */ 2,
    _0: file.key,
    _1: "Reselect this file to upload it."
  });
}

function dispatch(t, target, action) {
  if (!allowed(target, Curry._1(t.model, undefined))) {
    return;
  }
  switch (action.TAG) {
    case /* Selected */ 0 :
      const captured = scope(target, Curry._1(t.model, undefined));
      emit(t, target, action);
      return Stdlib__List.iter((function (param) {
        return upload(t, target, captured, param);
      }), action._0);
    case /* Uploaded */ 1 :
    case /* Upload_failed */ 2 :
      return;
    case /* Remove */ 3 :
      const key = action._0;
      Stdlib__Option.iter((function (param) {
        Mapre_web__Browser.abort(param[1]);
      }), Stdlib__Hashtbl.find_opt(t.uploads, key));
      Stdlib__Hashtbl.remove(t.uploads, key);
      return emit(t, target, action);
    case /* Retry */ 4 :
      const key$1 = action._0;
      return Stdlib__Option.iter((function (item) {
        const match = item.status;
        if (/* tag */ typeof match !== "object" && typeof match !== "function") {
          return;
        }
        if (match.TAG === /* Ready */ 0) {
          return;
        }
        emit(t, target, action);
        upload(t, target, scope(target, Curry._1(t.model, undefined)), item.file);
      }), Stdlib__List.find_opt((function (item) {
        return item.file.key === key$1;
      }), draft(target, Curry._1(t.model, undefined)).items));
    case /* Error */ 5 :
      return emit(t, target, action);
  }
}

function create(emit, model, failure) {
  return {
    emit,
    model,
    failure,
    uploads: Stdlib__Hashtbl.create(undefined, 8),
    generation: 0
  };
}

export {
  create,
  cancel,
  cancel_target,
  dispatch,
  allowed,
  draft,
}
/* Mapre_web__Browser Not a pure module */
